import { colorPalette } from 'ui-blocks/ColorPalette';

export const createImagineStyles = {
	createImagineContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', mobileUi: 'row' },
		gap: { xs: '16px', smTab: '32px', lg: '24px', xxl: '152px' },
		width: '100%',
	},
	imageContainer: {
		width: { xs: '14%', smTab: '16%' },
		aspectRatio: '1',
		zIndex: 1,
		position: 'absolute',
		top: '2px',
		left: '2px',
	},
	baseImage: {
		width: '100%',
		height: '100%',
		borderRight: `3px solid ${colorPalette.dark6}`,
		borderBottom: `3px solid ${colorPalette.dark6}`,
		borderRadius: '20px',
	},
	videoContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: { xs: '20px', lg: '24px' },
		padding: { xs: '17px 0 0 22px', smTab: '42px 0 0 52px', lg: '36px 0 0 46px' },
		borderTop: `2px solid ${colorPalette.dark1}`,
		borderLeft: `2px solid ${colorPalette.dark1}`,
		borderRadius: '20px',
	},
	baseVideo: {
		objectFit: 'cover',
		width: '100%',
		height: '100%',
	},
};
